export { PrintReportContainer, Page } from './styles';
export { default as Header } from './Header';
export { default as Table } from './Table';
